module.exports = __webpack_public_path__ + "20a821aab43eb4b6b171c6f2b64f909e.png";